import { useCallback } from 'react';

import { CreateMarginPosition } from '@swyftx/margin/build/types';

import { api } from '@shared/api';
import { UserStore } from '@shared/store';

import { useMarginAccount } from '../account';
import { useMarginPositionsCache } from '../positions';

const useCreateMarginPosition = () => {
  const { getUniqueIdentifier } = UserStore.useUserStore;
  const { account } = useMarginAccount();
  const { invalidateCache } = useMarginPositionsCache();

  const createPosition = useCallback(
    async (position: CreateMarginPosition) => {
      if (!getUniqueIdentifier() || !account || !account.traderAccountId) return;

      const response = await api.endpoints.createPosition({
        data: {
          swyftxUserId: getUniqueIdentifier(),
          traderAccountId: account.traderAccountId,
          ...position,
        },
      });

      invalidateCache();

      return response.data;
    },
    [account, getUniqueIdentifier, invalidateCache],
  );

  return {
    createPosition,
  };
};

export { useCreateMarginPosition };
